export default __webpack_public_path__ + "static/media/iced-tea.9abb09ee.webp";